export interface AuthTerminalLifecycleResources {
  deactivate?: () => void;
  dispose: () => void;
}

type ScheduleTimer = (callback: () => void) => ReturnType<typeof setTimeout>;
type CancelTimer = (handle: ReturnType<typeof setTimeout>) => void;

export function scheduleAuthTerminalLifecycle(
  initialize: () => AuthTerminalLifecycleResources,
  scheduleTimer: ScheduleTimer = (callback) => setTimeout(callback, 0),
  cancelTimer: CancelTimer = (handle) => clearTimeout(handle)
): () => void {
  let resources: AuthTerminalLifecycleResources | null = null;
  let cleanedUp = false;
  let initializeTimer: ReturnType<typeof setTimeout> | null = scheduleTimer(() => {
    initializeTimer = null;
    if (cleanedUp) return;
    resources = initialize();
  });

  return () => {
    if (cleanedUp) return;
    cleanedUp = true;

    if (initializeTimer !== null) {
      cancelTimer(initializeTimer);
      initializeTimer = null;
      return;
    }

    if (!resources) return;
    const resourcesToDispose = resources;
    resources = null;
    try {
      resourcesToDispose.deactivate?.();
    } finally {
      // xterm 5.5 schedules an untracked Viewport.syncScrollArea timer in open().
      // Queue disposal after that timer so it can still read render dimensions.
      scheduleTimer(() => resourcesToDispose.dispose());
    }
  };
}
